/**
 * Home Claim tax back prompt dismissal. Client-only, like the welcome card:
 * the live profile API would ignore an unknown field, so this lives in
 * localStorage keyed by donor email.
 */

const STORAGE_PREFIX = 'swiftaid-claim-tax-back-prompt-dismissed-v1'
const dismissedInMemory = new Set<string>()

function storageKey(donorKey: string): string {
  return `${STORAGE_PREFIX}:${donorKey}`
}

/** Normalise the donor id used in the storage key. */
export function claimPromptDonorKey(emailAddress: string | null | undefined): string {
  return emailAddress?.trim().toLowerCase() ?? ''
}

/** Whether this donor has dismissed the Claim tax back home prompt. */
export function isClaimTaxBackPromptDismissed(donorKey: string): boolean {
  if (!donorKey) return false
  if (dismissedInMemory.has(donorKey)) return true
  try {
    return localStorage.getItem(storageKey(donorKey)) === '1'
  } catch {
    return false
  }
}

/** Hide the prompt for this donor until they clear site data. */
export function persistClaimTaxBackPromptDismissed(donorKey: string): void {
  if (!donorKey) return
  dismissedInMemory.add(donorKey)
  try {
    localStorage.setItem(storageKey(donorKey), '1')
  } catch (error) {
    console.warn('Could not persist claim tax back prompt dismissal', error)
  }
}

/** Test helper: drop in-memory dismissal after localStorage.clear(). */
export function resetClaimTaxBackPromptDismissedMemory(): void {
  dismissedInMemory.clear()
}
